import { Field } from 'Util/Query';

export class TeasingPageQuery {
    getData() {
        return new Field('getTeasingPageData')
            .addFieldList(this.getDataFields());
    }

    getDataFields() {
        return [
            'is_active',
            'start_date',
            'end_date',
            'today',
            'banner_image',
            'banner_image_inactive',
            'banner_link',
            'title',
            'counter_title_before',
            'counter_title_after',
            'newsletter_title',
            'active_block_title',
            'active_button_title',
            'active_button_title_logged_in',
            'active_button_link',
            'active_button_link_logged_in',
        ];
    }
}

export default new TeasingPageQuery();
